import { useQuery } from "@tanstack/react-query";

import { getLeadSources } from "@/api";

export function useLeadSources() {
  return useQuery({
    queryKey: ["leadSources", "getLeadSources"],
    queryFn: () => getLeadSources(),
  });
}
